import { Media } from './media.model';
import { Tag } from 'app/core/models';

export enum ProcessAuthorizationType {
  IsPrivate = 1,
  Emails = 2,
  Domains = 3
}

export enum ProcessUsageTypes{
    Process = 1,
    ProcessAndTemplate = 2,
    Template = 3
}

export class ProcessAuthorization {
  rowId: number;
  processId: number;
  authorizationType: number;
  audience: string;
}

export class Process {
    canEdit: boolean;
    isPublished: boolean;
    creationDate: string;
    publishedDate: string;
    createdBy: string;
    createdByImageUrl: string;
    processId: number;
    title: string;
    description: string;
    processVersionId: string;
    stages: ProcessStage[];
    analytics: ProcessAnalytics;
    coverSmallUrl: string;
    color: string;
    createdByInitials: string;
    tags: Tag[];
    hasLiked: boolean;
    lastModified: string;
    isPremium: boolean;
    allowAssistance: boolean;
    isArchived: boolean;
    coverMediaId: string;
    isRTL: boolean;
    processAuthorization: ProcessAuthorization[];
    usageType: ProcessUsageTypes;
}

export class ProcessAnalytics {
    likes: number;
    views: number;
    executions: number;
    duplicationCount: number;
}
export class ProcessStage {
    title: string;
    order: number;
    steps: ProcessStep[];

    constructor() {
        this.title = '';
        this.order = 1;
        this.steps = [new ProcessStep()];
    }
}
export class ProcessStep {
    title: string;
    order: number;
    stepTypeId: number;
    textHtml: string;
    medias: Media[];
    documents: Media[];
    tasks: string[];
    showTasks: boolean;
    newTaskTitle: string;

    constructor() {
        this.title = '';
        this.order = 1;
        this.documents = [];
        this.medias = [];
        this.stepTypeId = null;
        this.textHtml = '';
        this.tasks = [];
        this.showTasks = false;
        this.newTaskTitle = '';
    }
}

export enum ProcessGroups {
    Likes = 0,
    Recents = 1,
    Views = 2,
    Executions = 3,
    Editing = 4,
    Executing = 5,
    EditingAndExecuting = 6,
    Published = 7,
    Tags = 8
}

export interface ProcessGroup {
    group: ProcessGroups;
    groupTitle: string;
    items: Process[];
    slides: Process[][];
    isLoading: boolean;
}

export interface CreateProcess {
    title: string,
    description: string
}


export interface ExecutionDetails {
    processExecutionId: string;
    creationDate: string;
    lastModificationDate: string;
    completionDate: string;
    isCompleted: boolean;
    currentStep: number;
    currentStage: number;
    stages: Array<ExecutionStage>;
}

export interface ExecutableProcess {
    executionDetails: ExecutionDetails;
    processDetails: Process;
}

export interface SaveProcessExecutionModel {
    processExecutionId: string;
    currentStep: number;
    currentStage: number;
    stages: Array<ExecutionStage>;
}

export interface TagCataegoryGroup {
    tagId: number;
    groupTitle: string;
    items: Process[];
    slides: Process[][];
    isLoading: boolean;
}

export interface ProcessPublishModel {
    processVersionId: string;
    isPremium: boolean;
    allowAssistance: boolean;
    coverMediaId?: string;
    processAuthorization?: Array<ProcessAuthorization>;
    usageType: number;
}

export interface SaveProcessTagsModel {
    processVersionId: string;
    tags: Array<Tag>;
}

export interface ContactProcessCreatorModel {
    processExecutionId: string;
    message: string;
    stageOrder: number;
    stageTitle: string;
    stepOrder: number;
    stepTitle: string;
}

export interface ExecutionStep {
    tasks: Array<boolean>;
}

export interface ExecutionStage {
    steps: Array<ExecutionStep>;
}




// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/core/models/process.model.ts